import { Module } from 'vuex'
import axios from 'axios'
import { BASE_API_URL } from '@/config'
import { Sensor } from './sensor'
import { Alarm } from './alarm'
import { Warning } from './warning'
import { Company } from './company'
export interface MachineOverview {
  id: string
  company: Company
  location: string
  lineGroup: string
}
export interface MachineDetail {
  id: string
  company: Company
  location: string
  lineGroup: string
  sensors: Sensor[]
  alarms: Alarm[]
  warnings: Warning[]
}
export interface AddMachine {
  id: string
  oldId: string
  companyId: number
  location: string
  sensors: number[]
  alarms: number[]
  warnings: number[]
}
export type EditMachine = AddMachine
export interface MachineStore {
  machines: MachineOverview[]
}
export const machineStore: Module<MachineStore, {}> = {
  namespaced: true,
  state: () => ({
    machines: []
  }),
  mutations: {
    getAll(state, payload: MachineDetail[]) {
      state.machines = payload
    }
  },
  actions: {
    async getAll({ commit }) {
      const { data } = await axios.get(`${BASE_API_URL}/machine`)
      commit('getAll', data)
    },
    async add({ dispatch }, payload: AddMachine) {
      const { data } = await axios.post(`${BASE_API_URL}/machine`, payload)
      await dispatch('getAll')
      return data
    },
    async edit({ dispatch }, { id, oldId, ...machine }: EditMachine) {
      const { data } = await axios.put(`${BASE_API_URL}/machine/${oldId}`, {
        id,
        ...machine
      })
      await dispatch('getAll')
      return data
    },
    async get(_, id: string) {
      const { data } = await axios.get(`${BASE_API_URL}/machine/${id}`)
      return data
    }
  },
  getters: {
    machines: state => state.machines
  }
}
